module.exports = __webpack_public_path__ + "./SusanPhoto_87b11cb5832510f4d1beb9416c74a000.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/SusanPhoto.png
// module id = 543
// module chunks = 0